import GeneralSettings from "@/pages/settings/components/general_settings/General_Settings";
import SettingsMenu from "@/pages/settings/components/SettingsMenu";

const SettingsHome = () => {
  return (
    <div className="relative w-full h-full">
      {/* Fixed Settings Menu section - positioned within the content area */}
      <div
        className="hidden lg:block lg:fixed lg:w-[350px]"
        style={{
          height: "calc(100vh - 64px)",
          top: "64px", // Match your header height
          left: "var(--sidebar-width)", // Match your dashboard sidebar width
        }}>
        <div className="lg:overflow-y-auto lg:h-full lg:pr-3 hide-scrollbar">
          <SettingsMenu />
        </div>
      </div>

      {/* Settings Content section with appropriate margin */}
      <div className="hidden lg:block" style={{ marginLeft: "calc(370px)" }}>
        <div className="py-6">
          <GeneralSettings />
        </div>
      </div>

      {/* Mobile view */}
      <div className="lg:hidden">
        <SettingsMenu />
      </div>
    </div>
  );
};

export default SettingsHome;
